/**
 * تنسيق تاريخ المقال بشكل متسق — يعرض الأرقام بالإنجليزية دائماً
 */
function toLatinNumerals(str: string): string {
  return str
    .replace(/[٠-٩]/g, (w) => String.fromCharCode(w.charCodeAt(0) - 0x0660 + 0x30))
    .replace(/[۰-۹]/g, (w) => String.fromCharCode(w.charCodeAt(0) - 0x06F0 + 0x30));
}

export function formatArticleDate(dateStr: string | undefined | null, lang: string = "ar"): string {
  if (!dateStr) return "";
  const locale = lang === "en" ? "en-US" : "ar-SA";
  const d = new Date(dateStr);
  if (!isNaN(d.getTime())) {
    return toLatinNumerals(
      d.toLocaleDateString(locale, {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    );
  }
  // fallback: convert Arabic numerals to Latin then try again
  const normalized = String(dateStr)
    .replace(/[٠-٩]/g, (w) => String.fromCharCode(w.charCodeAt(0) - 0x0660 + 0x30))
    .replace(/[۰-۹]/g, (w) => String.fromCharCode(w.charCodeAt(0) - 0x06F0 + 0x30));
  const d2 = new Date(normalized);
  if (!isNaN(d2.getTime())) {
    return toLatinNumerals(
      d2.toLocaleDateString(locale, {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    );
  }
  return toLatinNumerals(String(dateStr));
}